import { browserName, browserVersion } from 'react-device-detect';

export const isSafariUnder14 =
  browserName === 'Mobile Safari' && parseInt(browserVersion, 10) <= 14;
